export default {
  root: {
    textAlign: 'center',
    marginTop: '16px',
    padding: '0px',
  },
};
